import { CommonCardWrapper } from "../../styles/StyledComponents/CommonCardWrapper";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { ICommonCardProps } from "../../ui/interface";

const CommonCard = ({
  description,
  title,
  cardClick,
  typeofCard,
  ExperienceLevel,
  JobType,
  Location,
  Vacancies,
  carrerBgImg,
  ...props
}: ICommonCardProps) => {
  return (
    <CommonCardWrapper {...props}>
      {typeofCard === "service" ? (
        <>
          <h3>{title}</h3>
          <p>{description}</p>
          <div className="btn_wrap">
            <CommonButton
              variant="contained"
              color="primary"
              className="card_button"
              onClick={cardClick}
            >
              learn more
            </CommonButton>
          </div>
        </>
      ) : (
        <>
          {carrerBgImg && (
            <figure>
              <img src={carrerBgImg} alt="carrerBgImg" />
            </figure>
          )}
          <div className="inner_text">
            <div className="cardDetails">
              <h3>{title}</h3>
              <p>{description}</p>
              <p>
                Level of Experience <span>{ExperienceLevel}</span> Years
              </p>
              <p>
                Job Type <span>{JobType}</span>
              </p>
              <p>
                Location <span>{Location}</span>
              </p>
              <p>
                Vacancies <span>{Vacancies}</span>
              </p>
            </div>
            <div className="btn_wrap">
              <CommonButton
                variant="contained"
                color="primary"
                fullWidth
                style={{ minWidth: "auto" }}
                onClick={cardClick}
              >
                Apply Now
              </CommonButton>
            </div>
          </div>
        </>
      )}
    </CommonCardWrapper>
  );
};

export default CommonCard;
